<template>
  <div class="timeCircleContainer">
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="45" :stroke="color" :stroke-dashoffset="dashoffset" />
    </svg>
    <span :style="{color: color}">
      {{ time ? stringifyDuration(time) : time }}
    </span>
  </div>
</template>

<script>
  import { stringifyDurationMixin } from '@/mixins/stringifyDurationMixin';

  export default {
    name: 'TimeCircleElement',
    mixins: [stringifyDurationMixin],
    props: {
      time: {
        default: 0,
      },
      color: {
        default: '#3780DF',
      },
    },
    computed: {
      dashoffset: function () {
        if (this.time >= 720) {
          return 0;
        } else if (this.time < 0) {
          return 283;
        } else {
          return -(283 - this.time * 0.393);
        }
      },
    },
  };
</script>

<style scoped>
  svg {
    /*animation: 2s linear infinite svg-animation;*/
    max-width: 60px;
    position: absolute;
  }

  @keyframes svg-animation {
    0% {
      transform: rotateZ(0deg);
    }
    100% {
      transform: rotateZ(360deg)
    }
  }

   circle {
     transition-duration: .5s;
     display: block;
     fill: transparent;
     stroke-linecap: round;
     stroke-dasharray: 283;
     stroke-width: 5px;
     transform-origin: 50% 50%;
     transform: rotate(-90deg);
   }

  .timeCircleContainer {
    position: relative;
    width: 60px;
    height: 60px;
  }

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-style: normal;
      font-weight: bold;
      font-size: 15px;
    }
</style>
